module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration012.4c0ab693.webp";